import classNames from "classnames";
import React from "react";

import { useAppSelector } from "../../reducers";
import { defaultState } from "../defaults";
import { Filter, IProps as IFilterProps } from "./Filter";

import styles from "./TopFilterSection.module.scss";

interface IProps extends IFilterProps {
    isMobile: boolean;
}

export const TopFilterSection = (props: IProps) => {
    const facets = useAppSelector(
        (state) => (state.reviews || defaultState).data.facets,
    );

    const filterClasses = classNames({
        [styles.topFilters]: true,
    });
    return (
        <div className={filterClasses}>
            {facets.map((facet) => (
                <Filter {...props} key={facet.type} facet={facet} />
            ))}
        </div>
    );
};
